import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Expand = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M36 33C35.4477 33 35 32.5523 35 32L35 8C35 7.44772 35.4477 7 36 7C36.5523 7 37 7.44772 37 8L37 32C37 32.5523 36.5523 33 36 33ZM19.2929 31.7071C18.9024 31.3166 18.9024 30.6834 19.2929 30.2929L28.5858 21L4 21C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19L28.5858 19L19.2929 9.70711C18.9024 9.31658 18.9024 8.68342 19.2929 8.29289C19.6834 7.90237 20.3166 7.90237 20.7071 8.29289L31.7071 19.2929C31.8946 19.4804 32 19.7348 32 20C32 20.2652 31.8946 20.5196 31.7071 20.7071L20.7071 31.7071C20.3166 32.0976 19.6834 32.0976 19.2929 31.7071Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Expand;
